import React from 'react';

export default class InlineTextInput extends React.Component {

	handleChange(e) {
		if (this.props.onChange) {
			this.props.onChange(this.getValue(e))
		}
	}

	handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.getValue(e))
		}
	}

	handleKeyDown(e) {
		var ENTER = 13;
		if(e.keyCode == ENTER) {
			if (this.props.onSave) {
				this.props.onSave(this.getValue(e))
			}
		}
	}

	getValue(e) {
		const value = e.target.value;
		if (value === '') {
			return null;
		}
		else {
			return value
		}
	}

	render() {
		const val = typeof this.props.value != 'undefined' && this.props.value != null ? this.props.value.toString() : '';
		return (
			<input type="text"
				   className="form-control"
				{...this.props}
				   value={val}
				   onChange={(e) => this.handleChange(e)}
				   onBlur={(e) => this.handleBlur(e)}
				   onKeyDown={(e) => this.handleKeyDown(e)}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/InlineTextInput.js